import { GridAction } from '@eforall/dashboard';
import { AccApplicationDialogDataService } from '../../acc-application-dialog-data.service';
import { AlignedAccelerator } from '../aligned-accelerators.part';

export function getActions(accApplicationDialogDataService: AccApplicationDialogDataService) {

	const actions: GridAction<AlignedAccelerator>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'Offer Seat',
			isEnabled: rows => {
				if (accApplicationDialogDataService.isReadonly()) return false;
				return !!rows.length
			},
			execute: async (rows) => {
				const accApplicationId = accApplicationDialogDataService.dialogData()?.details.accApplicationId;
				if (!accApplicationId) return;
				await accApplicationDialogDataService.confirmAndAssignOfferedSeat(rows[0]!.accId, rows[0]!.availableSeatCount);
			}
		},
		{
			iconClass: 'fa-regular fa-xmark',
			label: 'Remove Offered Seat',
			isEnabled: rows => {
				if (accApplicationDialogDataService.isReadonly()) return false;
				return !!rows.length && !!rows[0] && rows[0].seatOffered
			},
			execute: async (rows) => {
				const accApplication = accApplicationDialogDataService.dialogData()?.details;
				if (!accApplication) return;
				await accApplicationDialogDataService.confirmAndRemoveOfferedSeatAccId();

			},
		}
	];

	return actions;
}